import "@sendbird/uikit-react/dist/index.css";
import { BrowserRouter } from "react-router-dom";
import "./assets/styles/body.module.scss";
import "./assets/styles/reset.module.scss";
import { LoginUserProvider } from "./providers/LoginUserProvider";
import { SiteProvider } from "./providers/SiteProvider";
import { Router } from "./router/Router";

function App() {
  return (
    <SiteProvider>
      <LoginUserProvider>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </LoginUserProvider>
    </SiteProvider>
  );
}

export default App;
